// TODO look over list...
const KnownNamespaces = {
  rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
  owl: 'http://www.w3.org/2002/07/owl#',
  actuation: 'https://w3id.org/rec/actuation/',
  agents: 'https://w3id.org/rec/agents/',
  analytics: 'https://w3id.org/rec/analytics/',
  asset: 'https://w3id.org/rec/asset/',
  building: 'https://w3id.org/rec/building/',
  business: 'https://w3id.org/rec/business/',
  collections: 'https://w3id.org/rec/collections/',
  core: 'https://w3id.org/rec/core/',
  dataschemas: 'https://w3id.org/rec/dataschemas/',
  device: 'https://w3id.org/rec/device/',
  example: 'https://w3id.org/rec/example/',
  lease: 'https://w3id.org/rec/lease/',
  lfr: 'https://w3id.org/rec/lfr/',
  metadata: 'https://w3id.org/rec/metadata/',
  unit: 'http://qudt.org/vocab/unit/',
  quantitykind: 'http://qudt.org/vocab/quantitykind/',
  dcmi: 'http://purl.org/dc/terms/',
  xsd: 'http://www.w3.org/2001/XMLSchema#',
  geo: 'http://www.opengis.net/ont/geosparql#',
  foaf: 'http://xmlns.com/foaf/0.1/',
  rec: 'https://w3id.org/rec#',
}

class Namespaces {
  constructor(namespaces = {}) {
    this.namespaces = Object.assign(KnownNamespaces, namespaces)
  }

  // Extract and return the short name of the IRI.
  shorten(iri) {
    if (iri?.includes('#')) return iri.split('#').pop()
    if (iri?.includes('/')) return iri.split('/').pop()
    return iri
  }

  // Replace known namespace of IRI with prefix and return.
  prefix(iri) {
    if (!iri) {
      return iri
    }
    // TODO consider REGEX.
    for (const [prefix, ns] of Object.entries(this.namespaces)) {
      if (iri.includes(ns)) {
        return iri.replace(ns, prefix + ':')
      }
    }
    return iri
  }

  // Expand prefixed name for known namespaces to full IRI and return.
  expand(iri) {
    if (!iri) {
      return iri
    }
    const [prefix, shortName] = iri.split(':')
    if (shortName && this.namespaces[prefix]) {
      return this.namespaces[prefix] + shortName
    }
    return iri
  }
}

export { KnownNamespaces, Namespaces }
